import ApiService from './api.service'
import type {
  ProvisioningRequestResponse,
  ProvisioningRequestListResponse,
  ProvisioningRequestData,
  ProvisioningResponseData
} from '@/types/services'

class ProvisioningRequestService extends ApiService {
  constructor() {
    super({
      showNotifications: true,
      notificationOptions: {
        title: 'Provisioning Request Service Error'
      }
    })
  }

  /**
   * Create a new provisioning request
   */
  async createRequest(
    projectId: string | number,
    data: ProvisioningRequestData
  ): Promise<ProvisioningRequestResponse | null> {
    const formData = new FormData()
    formData.append('requestedAmount', data.requestedAmount.toString())
    formData.append('description', data.description)
    formData.append('provisionDeadline', data.provisionDeadline)

    return this.post(`/api/project/${projectId}/provisioning-requests`, formData)
  }

  /**
   * Get all provisioning requests for a project
   */
  async getRequests(projectId: string | number): Promise<ProvisioningRequestListResponse | null> {
    return this.get(`/api/project/${projectId}/provisioning-requests`)
  }

  /**
   * Get pending provisioning requests for a project
   */
  async getPendingRequests(projectId: string | number): Promise<ProvisioningRequestListResponse | null> {
    return this.get(`/api/project/${projectId}/provisioning-requests/pending`)
  }

  /**
   * Reject a provisioning request
   */
  async rejectRequest(
    projectId: string | number,
    requestId: string | number,
    data: ProvisioningResponseData
  ): Promise<ProvisioningRequestResponse | null> {
    const formData = new FormData()
    if (data.responseNotes) {
      formData.append('responseNotes', data.responseNotes)
    }

    return this.post(`/api/project/${projectId}/provisioning-requests/${requestId}/reject`, formData)
  }

  /**
   * Get count of pending provisioning requests
   */
  async getPendingCount(projectId: string | number): Promise<number> {
    const response = await this.get<number>(`/api/project/${projectId}/provisioning-requests/pending/count`)
    return response || 0
  }
}

// Export singleton instance
export const provisioningRequestService = new ProvisioningRequestService()
export default provisioningRequestService
